export const getImageFileFromBlob = (blob: any) => {
  if (blob instanceof ArrayBuffer) {
    // Not using TextDecoder as it's unsupported in Edge browsers
    // while DataViewer is supported in older IE
    const dataViewer = new DataView(blob);
    const first4LettersInBlob = String.fromCharCode(
      dataViewer.getInt8(0),
      dataViewer.getInt8(1),
      dataViewer.getInt8(2),
      dataViewer.getInt8(3),
    );
    if (first4LettersInBlob === '%PDF') {
      return new File([blob], `pdf_${new Date().getTime()}.pdf`, { type: 'application/pdf' });
    }
  }
  return new File([blob], `camera_${new Date().getTime()}.jpeg`, { type: 'image/jpeg' });
};

export function base64ToBlob(base64: string, defaultMime: string = 'application/octet-stream'): Blob {
  const isDataUrl = /^data:.*;base64,/.test(base64);
  let mime = defaultMime;
  let b64 = base64;

  if (isDataUrl) {
    const [header, payload] = base64.split(',');
    const match = header.match(/^data:(.*);base64$/);
    if (match?.[1]) mime = match[1];
    b64 = payload;
  }

  const paddingNeeded = b64.length % 4;
  if (paddingNeeded) {
    b64 += '='.repeat(4 - paddingNeeded);
  }

  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return new Blob([bytes], { type: mime });
}

export const isMobileBrowser = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
